import { createApiHook } from '../hooks';
import { authenticationApiFactory } from './authenticationApiFactory';

export const useAuthenticationApi = createApiHook(authenticationApiFactory);
